import { userInfoStore } from '../../../store/userInfoStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { autoBetStore } from '../../../store/autoBetStore';
import { baccaratBetsStore } from '../baccaratStore/betStore';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { DEFAULT_AUTO_BET_COUNT } from '../../../core/constants/autoBetContants';
import { wheelBetsStore } from '../../wheel/wheelStore/betStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { TranslationKeys } from '../../../core/constants/translationKeys';
import { soundService } from '../../../services/baseSoundService/soundService';
import { BaccaratSoundsName } from '../baccaratCore/constants/sounds';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { freeBetStore } from '../../../store/freeBetStore';

let resetTimeOutId;
let animationTimeOut;

class BaccaratGameService {
  onGetInitialStateResult({ lastSpinInfo }) {
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo({
        key: lastSpinInfo.key,
        salt: lastSpinInfo.salt,
        hash: lastSpinInfo.hash,
      });
      checkHashStore.setLastRoundResult({
        id: lastSpinInfo.id,
        date: lastSpinInfo.date,
        cards: lastSpinInfo.cards,
        markets: lastSpinInfo.markets,
        playerTotalPoints: lastSpinInfo.playerTotalPoints,
        bankerTotalPoints: lastSpinInfo.bankerTotalPoints,
      });
    }
    checkHashStore.setNextHashTextInfo(TranslationKeys.NextCards);
  }

  doSpin() {
    if (
      autoBetStore.isAutoBetOn &&
      !autoBetStore.isAutoBetStart &&
      baccaratBetsStore.lastBetModel.betModel
    ) {
      autoBetStore.setIsAutoBetStart(true);
    }
    if (!baccaratBetsStore.isBetsClosed && baccaratBetsStore.lastBetModel.betModel) {
      soundService.play(BaccaratSoundsName.bet);
      baccaratBetsStore.removeTableCards();
      const model = baccaratBetsStore.lastBetModel.betModel.map(({ type, amount }) => ({
        type,
        amount,
      }));
      mainGameConnection.doSpin(
        {
          spinData: { markets: model },
          isAutoplay: autoBetStore.isAutoBetOn,
          isTurbo: userSettingsStore.isTurboOn,
        },
        false
      );
      baccaratBetsStore.setIsBetsClosed(true);
    }
  }

  handleDoSpinResult({
    responseCode,
    result,
    winAmount,
    odd,
    newHash,
    salt,
    freebetInfo,
    key,
    hash,
    id,
    balance,
  }) {
    const { setIsAutoBetStart, isAutoBetStart } = autoBetStore;
    const { betsModels } = baccaratBetsStore;
    if (responseCode === ValidationType.Success) {
      const { winType, playerTotalPoints, bankerTotalPoints, cards, sideBetWinType } = result;
      const { currentFreeBet } = freeBetStore;
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
      }
      if (currentFreeBet && betsModels.length > currentFreeBet.remainingCount) {
        if (isAutoBetStart) {
          setIsAutoBetStart(false);
        }
        baccaratBetsStore.betsModels = [];
      }
      if (freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(freebetInfo);
      }
      if (!currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      for (let i = 0; i < cards.length; i += 1) {
        baccaratBetsStore.updateTableCards(cards[i], i);
      }
      setTimeout(
        () => {
          baccaratBetsStore.setBankerTotalPoints(bankerTotalPoints);
          baccaratBetsStore.setPlayerTotalPoints(playerTotalPoints);
          baccaratBetsStore.setWinType(winType);
          baccaratBetsStore.setSideWinType(sideBetWinType);
          baccaratBetsStore.updateResultSaltAndKey({
            salt,
            key,
            hash,
            newHash,
            odd,
            id,
            cards,
          });

          setTimeout(() => {
            soundService.play(odd ? BaccaratSoundsName.winTurbo : BaccaratSoundsName.lose);
            baccaratBetsStore.setWinOdd(odd);
            baccaratBetsStore.setWinAmount(winAmount);
            betHistoryStore.getLastBet();
            setTimeout(
              () => {
                userInfoStore.getBalance();
              },
              userSettingsStore.isTurboOn ? 500 : 0
            );
          }, 1000);
          setTimeout(() => {
            this.resetGameStoreData();
          }, 1500);
        },
        userSettingsStore.isTurboOn ? cards.length * 100 : cards.length * 500
      );
    } else {
      baccaratBetsStore.setIsBetsClosed(false);
      notificationStore.setNotification(responseCode);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.resetAutoBetState();
      }
    }
  }

  resetAutoBetState() {
    autoBetStore.setIsAutoBetStart(false);
    autoBetStore.setIsAutoBetOn(false);
    autoBetStore.setAutoBetCount(DEFAULT_AUTO_BET_COUNT);
    if (autoBetStore.isAutoBetStart && autoBetStore.isAutoBetOn && !autoBetStore.autoBetCount) {
      setTimeout(() => {
        autoBetStore.resetAutoBetState();
        this.clearAutoBetTimeOut();
      }, 1500);
    }
  }

  clearAutoBetTimeOut() {
    clearTimeout(resetTimeOutId);
    clearTimeout(animationTimeOut);
  }

  resetGameStoreData() {
    baccaratBetsStore.removeStore();
    resetTimeOutId = setTimeout(() => {
      wheelBetsStore.resetBetStore();
      if (autoBetStore.isAutoBetStart && autoBetStore.autoBetCount) {
        this.doSpin();
      } else {
        this.resetAutoBetState();
      }
    }, 200);
  }
}

export const baccaratGameService = new BaccaratGameService();
